import styles from './style.module.scss';
import { UIButton } from 'shared/ui';
import { TaskEntity } from 'shared/types';
import ArrowDownIcon from 'assets/icons/arrow-down-icon.svg?react';
import CompletedIcon from 'assets/icons/completed-icon.svg';
import { TASK_STATUS } from 'shared/constants';
import { useTranslation } from 'react-i18next';
import { memo, useMemo } from 'react';
import { AmountWithTokenData, DON_TOKEN } from 'components';

type Props = {
  task: TaskEntity;
  onClick: (task: TaskEntity) => void;
};

const isEqual = (prev: Props, next: Props) =>
  prev.task.id === next.task.id && prev.task.status === next.task.status;

export const Task = memo(({ task, onClick }: Props) => {
  const { t } = useTranslation();
  const { award_value, title, status, icon } = task;

  const handleClick = () => {
    onClick(task);
  };

  const rightControl = useMemo(() => {
    // No controls for completed tasks
    if (status === TASK_STATUS.DONE) return null;

    if (status === TASK_STATUS.TO_DO) return null;
    // {
    //   return (
    //     <div className={styles.arrowContainer}>
    //       <ArrowDownIcon className={styles.arrow} />
    //     </div>
    //   );
    // }
    if (status === TASK_STATUS.PENDING) {
      return (
        <UIButton size="small2" fontVariant="Button2" className={styles.button}>
          {t('common.pending')}
        </UIButton>
      );
    }

    return null;
  }, [status, t]);

  return (
    <div
      className={`${styles.root} ${status === TASK_STATUS.DONE ? styles.completed : ''}`}
      onClick={handleClick}
    >
      {/* Green checkmark for completed tasks */}
      {status === TASK_STATUS.DONE && (
        <img src={CompletedIcon} alt="" className={styles.completedIcon} />
      )}

      <img src={icon} alt="" width={40} height={40} />

      <div className={styles.info}>
        <div className={styles.text}>
          <span className={styles.title}>{title}</span>
          <div className={styles.awardAmount}>
            <AmountWithTokenData
              amount={`${award_value}`}
              token={DON_TOKEN}
              decimals={0}
              tokenTitle={false}
            />
          </div>
        </div>

        {rightControl && <div className={styles.rightContainer}>{rightControl}</div>}
      </div>
    </div>
  );
}, isEqual);
